import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import './index.less';

import actions from 'Actions/taskManage/questionNaire';

import echarts from 'echarts/lib/echarts';
import ReactEcharts from 'echarts-for-react';
import EmptyImg from 'Static/images/empty.png';

class Pie extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      projectData: [],
      average: 0,
    };
  }

  componentDidMount() {
    // const {actions} = this.props;
    // actions.getQuestionNaireAnswer({
    //   startMillis: 0,
    //   endMillis: 0,
    //   taskId: 0,
    // });
  }

  componentWillReceiveProps(nextProps) {
    const {barData} = this.props;
    if (JSON.stringify(nextProps.barData) !== JSON.stringify(barData)) {
      let num = 0;
      let denominator = 0;
      let molecule = 0;
      for (let i = 0; i < nextProps.barData.length; i++) {
        molecule += nextProps.barData[i].name * nextProps.barData[i].value;
        denominator += nextProps.barData[i].value;
      }
      num = (molecule / denominator).toFixed(2);

      this.setState({
        projectData: nextProps.barData,
        average: num,
      });
    }
  }

  onclick = {
    click: this.clickEchartsPie.bind(this),
  };

  clickEchartsPie(e) {
    const zoomSize = 6;
    const {projectData} = this.state;
    const dataX = projectData.map(e => e.name);
    if (this.echart) {
      this.echart.dispatchAction({
        type: 'dataZoom',
        startValue: dataX[Math.max(e.dataIndex - zoomSize / 2, 0)],
        endValue: dataX[Math.min(e.dataIndex + zoomSize / 2, dataX.length - 1)],
      });
    }
  }

  getEchart = e => {
    if (e) {
      this.echart = e.getEchartsInstance();
    }
  };

  getOption = data => {
    const dataX = data.map(e => e.name);
    const dataY = data.map(e => e.value);
    const option = {
      color: ['#40AEFC'],
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#fff',
        textStyle: {
          color: '#191F25',
        },
        axisPointer: {
          type: 'shadow',
        },
        formatter: '题目数量{b} <br/>{a}: {c} ',
      },
      axisLabel: {
        interval: 0,

        formatter(value) {
          let ret = ''; // 拼接加\n返回的类目项
          if (value.length > 3) {
            // 如果类目项的文字大于3,
            ret += `${value.substring(0, 4)}...`; // 最终的字符串
            return ret;
          }
          return value;
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          data: dataX,
          axisTick: {
            alignWithLabel: true,
            lineStyle: {
              color: '#999999',
            },
          },
          axisLabel: {
            interval: 0, // 代表显示所有x轴标签显示
            color: '#999999',
          },
          axisLine: {
            lineStyle: {
              color: '#EDEDED',
            },
          },
        },
      ],
      dataZoom: [
        // 滑动条
        {
          type: 'inside',
          startValue: 0,
          endValue: 9,
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0, // 代表显示所有x轴标签显示
            color: '#999999',
          },
          nameLocation: 'start',
          splitLine: {
            lineStyle: {
              type: 'dashed',
            },
          },
          axisLine: {
            show: false,
          },
        },
      ],
      series: [
        {
          name: '用户数量',
          type: 'bar',
          barWidth: '20px',
          data: dataY,
        },
      ],
    };
    return option;
  };

  render() {
    const {projectData, average} = this.state;
    return (
      <div className="bar">
        <div className="title">
          <span>回答情况</span>
        </div>
        {average > 0 ? (
          <div className="average">平均回答题目数量：{average}</div>
        ) : null}
        {projectData.length > 0 ? (
          <ReactEcharts
            echarts={echarts}
            option={this.getOption(projectData)}
            notMerge
            lazyUpdate
            onEvents={this.onclick}
            ref={e => !!this.getEchart && this.getEchart(e)}
            style={{width: '95%', height: '85%'}}
            className="react_for_echarts"
          />
        ) : (
          <div className="empty-tips">
            <img src={EmptyImg} alt="" />
            <div>暂无数据</div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({taskManageQuestionNaire}) => ({
  barData: taskManageQuestionNaire.barData,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Pie);
